import React, { useRef } from "react";

/**
 * Contract Holder Program Performance Header-text Information Component
 * @returns {Element}
 * @constructor
 */
export default function Header() {
  const videoRef = useRef(null);
  return (<>
    <h1 className="page_title"> Contract Holder Program Performance</h1>

    <p className="p_content">The chart below is a current Program Performance rating by the SEWP
      Program Office based on the criteria described within the headings
      in each column. This does not constitute the official Past Performance
      ratings based on
      <a href="https://acquisition.gov/far/part-42#FAR_Subpart_42_15" target="_blank"> FAR Part 42.15</a>.
    </p>
    <p className="p_content">Reminder: If a best value decision for a delivery order award is being
      made, which may include the SEWP Program Performance criteria, the
      Request for Quote shall contain the evaluation criteria.
    </p>

    <div id="programPerformanceVideo">
      <a className="ProgramPerformance" target="_blank" href="/documents/ProgramPerformance.mp4" ref={videoRef}
         onClick={(event) => {
           event.preventDefault();
           videoPlayerHandler(videoRef.current);
         }}
      >
        <img src="/images/PLAY_50px.png" alt="PLAY" />
        Program Performance - Delivery Ratings</a>
    </div>
  </>);
}